import { buildFunnelPageTree, type FunnelPageRelationship, type FunnelPageSlot } from '../../../../logic';
import type { FunnelPageItem } from '../../../../types';

export type PageSlot = Extract<FunnelPageSlot, { kind: 'page' }>;

export interface PageGroup {
    rootId: number;
    pages: FunnelPageItem[];
    slot: PageSlot;
}

export function flattenSlot(slot: PageSlot): FunnelPageItem[] {
    const children = (slot.children ?? []).filter((c): c is PageSlot => c.kind === 'page');
    return [slot.page, ...children.flatMap(flattenSlot)];
}

export function buildGroupsFromPages(pages: FunnelPageItem[]): PageGroup[] {
    const slots = buildFunnelPageTree(pages);
    return slots
        .filter((s): s is PageSlot => s.kind === 'page')
        .map(slot => ({
            rootId: slot.page.page_id,
            pages: flattenSlot(slot),
            slot,
        }));
}

export function getRoleLabel(relationship: FunnelPageRelationship | undefined): string {
    if (!relationship) return 'Following Offer';
    switch (relationship.kind) {
        case 'lead_capture':
            return 'Entry Page';
        case 'main_offer':
            return 'Subsequent Offer';
        case 'upsell':
            return 'Upsell';
        case 'downsell':
            return 'Downsell';
        case 'follow_up':
        default:
            return 'Following Offer';
    }
}

export function branchTagFor(
    relationship: FunnelPageRelationship | undefined
): { label: string; colorClass: string } | null {
    if (!relationship) return null;
    switch (relationship.kind) {
        case 'upsell':
            return { label: 'Upsell', colorClass: 'text-positive-fg-positive-bold' };
        case 'downsell':
            return { label: 'Downsell', colorClass: 'text-warning-fg-warning-bold' };

        default:
            return null;
    }
}
